import { ApigeeAuthAdapter } from './AuthenticationService/authAdapters';
import authService from './authService';
import { Tokens } from './AuthenticationService/types';
import config from '../config';

const apigeeAuth = new ApigeeAuthAdapter({
  baseUrl: config.apigee.baseUrl,
  clientId: config.apigee.widgetAuth.clientId,
});

export async function getWidgetToken(): Promise<Tokens> {
  return apigeeAuth.refreshTokens(
    authService.tokensStorage.get().refreshToken!,
  );
}
